import { apiClient } from './apiClient';

export interface RelanceFollowUpDaysSettingResponse {
    followUpDays: number;
}

export const relanceFollowUpDaysService = {
    get: (): Promise<RelanceFollowUpDaysSettingResponse> =>
        apiClient.get<RelanceFollowUpDaysSettingResponse>('/company-settings/relance-follow-up-days'),

    set: (followUpDays: number): Promise<void> =>
        apiClient.put<void>('/company-settings/relance-follow-up-days', { followUpDays }),
};
